

import * as Configuration from '../../../app.constants.js';

export class SftpServersService {
  constructor($http, $q) {
    this.$http = $http;
    this.$q = $q;
  }

  /**
   * @deprecated
   * migrated in sftp-servers.service.ts
   */
  getSftpServersList(companyId) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-servers/';
    return this.$http.get(url);
  }

  createSftpServer(companyId, sftpServer) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-servers';
    return this.$http.post(url, sftpServer);
  }

  updateSftpServer(companyId, sftpServer) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-servers/' + sftpServer.id;
    return this.$http.put(url, sftpServer);
  }

  deleteSftpServer(companyId, sftpServer) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-servers/' + sftpServer.id;
    return this.$http.delete(url);
  }

  createSftpServerKey(companyId, sftpServer) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-servers/create-sftp-key/';
    return this.$http.post(url, sftpServer);
  }

  testSftpServerConnectivity(companyId, sftpServer) {
    let url = Configuration.constants.baseUrl
            + 'api/1.0/companies/' + companyId
            + '/sftp-servers/test-connectivity/';
    return this.$http.post(url, sftpServer);
  }

  static SftpServersFactory($http, $q) {
    return new SftpServersService($http, $q);
  }
}

SftpServersService.SftpServersFactory.$inject = ['$http', '$q'];

